import { render, staticRenderFns } from "./WidgetNotification.vue?vue&type=template&id=0d3d52cd&scoped=true"
import script from "./WidgetNotification.vue?vue&type=script&lang=ts"
export * from "./WidgetNotification.vue?vue&type=script&lang=ts"
import style0 from "./WidgetNotification.vue?vue&type=style&index=0&id=0d3d52cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d52cd",
  null
  
)

export default component.exports